<template>
  <layout-workflow>
    <template #subheader>
      <manage-users-header
        v-if="showInvite"
        :users="users"
        @user-invited="email => userInvited(email)"
      />
    </template>
    <div class="pl-4 pr-4 pb-4">
      <manage-users-table
        :memberships="memberships"
        :users="users"
        @invite-resent="email => userInvited(email)"
      />
    </div>
    <v-snackbar v-model="snackbar">
      Your invite has been sent to {{ emailForSnackbar }}!
      <v-btn text @click="clearSnackbar">Close</v-btn>
    </v-snackbar>
  </layout-workflow>
</template>

<script>
import LayoutWorkflow from '@/components/layout/LayoutWorkflow'
import ManageUsersTable from '@/components/manage/ManageUsersTable'
import ManageUsersHeader from '@/components/manage/ManageUsersHeader'
import { userService } from '@/services/user-service'
import { organizationService } from '@/services/organization-service'
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'

export default {
  components: { LayoutWorkflow, ManageUsersTable, ManageUsersHeader },
  data() {
    return {
      emailForSnackbar: null,
      org: {},
      snackbar: false,
      users: {}
    }
  },
  computed: {
    ...mapState({
      memberships: state => state.membership.memberships
    }),
    orgId() {
      return this.$route.params.orgId
    },
    showInvite() {
      return !_.get(this.org, 'sso', false)
    }
  },
  watch: {
    snackbar(newValue) {
      if (!newValue) {
        this.clearSnackbar()
      }
    }
  },
  async created() {
    this.org = await organizationService.get(this.orgId)
    this.GET_MEMBERSHIPS(this.orgId)
    this.updateUsers()
  },
  methods: {
    ...mapActions(['GET_MEMBERSHIPS']),
    async updateUsers() {
      this.users = _.keyBy((await userService.list(this.orgId)).data, 'id')
    },
    userInvited(email) {
      this.updateUsers()
      this.GET_MEMBERSHIPS(this.orgId)
      this.emailForSnackbar = email
      this.snackbar = true
    },
    clearSnackbar() {
      this.emailForSnackbar = null
      this.snackbar = false
    }
  }
}
</script>
